import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Wrapper = styled.div`
  background-color: ${theme.color.purple};
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  color: ${theme.color.white};
  text-align: left;
  font-family: ${theme.font.family.workSans};
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-top: 38px;
  margin-bottom: 3px;
`;

export const Content = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
`;

export const CantLoad = styled.div`
  margin-top: 24px;
  margin-bottom: 32px;
`;

export const Status = styled.a`
  font-weight: 600;
  text-decoration: underline;
  color: ${theme.color.white};
  display: inline-flex;
  align-item: center;
`;

export const Button = styled.span`
  color: ${theme.color.purple};
  background: ${theme.color.white};
  padding: 4px 16px;
  min-height: 40px;
  line-height: 14px;
  font-size: 14px;
  display: inline-flex;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 700;
  align-items: center;
  text-transform: none;
  transition: background 250ms;
  cursor: pointer;
  &:hover {
    background: ${theme.color.gray};
  }
`;
